import { makeStyles } from "@material-ui/core";
import { color } from "../../../assets/const/color";
export const useStyles = makeStyles(() => ({
    lend: {
        "& .MuiInputBase-root": {
            borderRadius: "50px",
            fontFamily: "inter !important",
          },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      // color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      background: "#FEB62C",
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
    
  },
  cardGaps: {
marginBottom:"20px",
marginTop:"20px"
  },
  add_course_text: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#00473E",
  },
  input_label: {
    marginRight:"20px",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  addLend: {
    width: "150px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
}));
